export default function SvgCheckboxNoActive() {
  return (
    <>
      <svg width="20px" cursor="pointer" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <g>
          <path
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M4 7.2v9.6c0 1.12 0 1.68.218 2.108a2 2 0 00.874.874c.427.218.987.218 2.105.218h9.606c1.118 0 1.677 0 2.104-.218.377-.192.683-.498.875-.874.218-.428.218-.986.218-2.104V7.197c0-1.118 0-1.678-.218-2.105a2.001 2.001 0 00-.875-.874C18.48 4 17.92 4 16.8 4H7.2c-1.12 0-1.68 0-2.108.218a1.999 1.999 0 00-.874.874C4 5.52 4 6.08 4 7.2z"
          ></path>
        </g>
      </svg>
    </>
  );
}
